import { render, staticRenderFns } from "./exchange.vue?vue&type=template&id=23d93377&scoped=true"
import script from "./exchange.vue?vue&type=script&lang=js"
export * from "./exchange.vue?vue&type=script&lang=js"
import style0 from "./exchange.vue?vue&type=style&index=0&id=23d93377&prod&scoped=true&lang=css"
import style1 from "./exchange.vue?vue&type=style&index=1&id=23d93377&prod&lang=scss&scoped=true"
import style2 from "./exchange.vue?vue&type=style&index=2&id=23d93377&prod&scoped=true&lang=css"
import style3 from "./exchange.vue?vue&type=style&index=3&id=23d93377&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d93377",
  null
  
)

export default component.exports